/**
 * 版本相关工具函数
 */

/**
 * 版本号映射函数
 * 将旧版本号映射为新版本号
 * @param {number} version - 原始版本号
 * @returns {number} 映射后的版本号
 */
export const mapVersionCode = (version) => {
  if (version === 10000500) return 40106500
  if (version === 10000400) return 40004000
  return version
}

/**
 * 字符串版本号映射函数
 * 将旧字符串版本号映射为新版本号
 * @param {string} version - 原始字符串版本号
 * @returns {string} 映射后的字符串版本号
 */
export const mapStringVersion = (version) => {
  if (version === '10.0.4') return '4.0.40'
  if (version === '10.0.5') return '4.1.65'
  return version
}
